import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Avatar, FontSizer } from 'components/project/ClerkScreen';
import { toBoolean } from 'stores/utils';
import {
  Container, Title, SubTitle, MonitorOnly,
} from './Styles';

const ChatTitleContainer = ({
  avatarUrl,
  title,
  subTitle,
  onMonitorChatOnly,
  chatFontSize,
}) => {
  
  const monitor = toBoolean(window.localStorage.getItem('monitorChatOnly'));
  useEffect(() => {
    if (monitor) {
      document.title = `${document.title} - (CHAT ONLY MODE)`;
      return;
    }
    document.title = `${document.title.replace(' - (CHAT ONLY MODE)', '')}`;
  }, [monitor]);


  return (
    <Container>
      <Title>{title}</Title>
      {subTitle && <SubTitle>{subTitle}</SubTitle>}
      {avatarUrl && <Avatar url={avatarUrl} />}
      <FontSizer storagePropName="chatFontSize" storedValue={chatFontSize} />
      <MonitorOnly>
        <input
          title={monitor ? 'Click to turn OFF chat-only mode and return to the default behavior.' : 'Click to turn ON chat-only mode. You will still be able to perform ALL operations on the clerk screen. \n\nThis will just prevent your interactions (ie. where mouse focus is) from syncing with other clerk screens.'}
          type="checkbox"
          checked={monitor}
          value={monitor}
          onChange={(e) => onMonitorChatOnly(e.target.checked)}
        />
        {monitor ? 'CHAT ONLY ON' : 'CHAT ONLY OFF'}
      </MonitorOnly>
    </Container>
  );
};

ChatTitleContainer.propTypes = {
  avatarUrl: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onMonitorChatOnly: PropTypes.func.isRequired,
};

ChatTitleContainer.defaultProps = {
  avatarUrl: null,
  title: null,
  subTitle: null,
};

export default ChatTitleContainer;
